import { render } from "./RecommendedProductCard.vue?vue&type=template&id=37d342bd&scoped=true"
import script from "./RecommendedProductCard.vue?vue&type=script&lang=js"
export * from "./RecommendedProductCard.vue?vue&type=script&lang=js"

import "./RecommendedProductCard.vue?vue&type=style&index=0&id=37d342bd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d342bd"]])

export default __exports__